import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortvariants'
})
export class SortvariantsPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
